'use strict';

/**
 * PLP tile image carousel (site preference plpTileImageCarousel) on top of the Bootstrap carousel already in the bundle.
 * Listeners are delegated on document, so tiles appended via AJAX need no initialization.
 */
const CAROUSEL = '.tile-carousel';
const EMPTY_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

/**
 * Swaps data-src -> src (and data-poster -> poster) for media in the given slides
 * @param {jQuery} $items - carousel items
 */
function load($items) {
    $items.find('[data-src]').each(function () {
        if (this.dataset.poster) this.setAttribute('poster', this.dataset.poster);
        this.setAttribute('src', this.dataset.src);
        this.removeAttribute('data-src');
    });
}

/**
 * Toggles arrow availability (data-at-start/data-at-end) and plays only the active slide's video
 * @param {Element} carousel - .tile-carousel element
 */
function sync(carousel) {
    var $items = $(carousel).find('.carousel-item');
    var index = $items.index($items.filter('.active'));

    carousel.setAttribute('data-at-start', index <= 0);
    carousel.setAttribute('data-at-end', index >= $items.length - 1);

    $items.find('video').each(function () {
        if ($(this).closest('.carousel-item').hasClass('active')) {
            var playing = this.play();
            if (playing && playing.catch) playing.catch(function () {});
        } else {
            this.pause();
        }
    });
}

// First interaction: create the Bootstrap instance (enables touch swipe) and load the next slide
$(document).on('mouseenter focusin touchstart', '.product-tile', function () {
    var $carousel = $(this).find(CAROUSEL);
    if ($carousel.length && !$carousel.data('bs.carousel')) {
        $carousel.carousel();
        load($carousel.find('.carousel-item.active').next());
    }
});

// Arrows (closest() instead of Bootstrap's data-target, so duplicate tiles on a page work)
$(document).on('click', CAROUSEL + ' [data-tile-carousel]', function (e) {
    e.preventDefault();
    $(this).closest(CAROUSEL).carousel($(this).data('tile-carousel'));
});

// Load the incoming slide and the one after it before the slide animates in
$(document).on('slide.bs.carousel', CAROUSEL, function (e) {
    var $next = $(e.relatedTarget);
    load($next.add($next.next()));
});

$(document).on('slid.bs.carousel', CAROUSEL, function () {
    sync(this);
});

/**
 * Replaces the slides with a swatch color's images
 * @param {Element} carousel - .tile-carousel element
 * @param {Array<{u: string, a: string, c: string, v: string}>} slides - compact slides from the swatch data-tile-slides
 * @returns {boolean} true when slides were replaced
 */
function setSlides(carousel, slides) {
    var $inner = $(carousel).find('.carousel-inner');
    if (!$inner.length || !Array.isArray(slides) || !slides.length) return false;

    var $first = $inner.find('.product-tile-image').first();

    $inner.empty().append(slides.map(function (slide, i) {
        var $media;
        if (i === 0) {
            $media = ($first.length ? $first.clone() : $('<img class="product-tile-image tile-image">')).removeAttr('loading').attr('src', slide.u);
        } else if (slide.v) {
            $media = $('<video class="tile-image" muted loop playsinline preload="none"></video>').attr({ 'data-src': slide.v, 'data-poster': slide.u });
        } else {
            $media = $('<img class="tile-image" decoding="async">').attr({ src: EMPTY_PLACEHOLDER, 'data-src': slide.u, alt: slide.a || '' });
        }

        return $('<div class="carousel-item"></div>').toggleClass('active', i === 0).append($media);
    }));

    load($inner.children().eq(1));
    $(carousel).closest('.product-tile-image-container')
        .removeClass('model-shot-tile product-shot-tile video-thumbnail-tile product-video-tile')
        .addClass(slides[0].c ? slides[0].c + '-tile' : '');
    sync(carousel);

    return true;
}

module.exports = {
    setSlides: setSlides
};
